import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import { ApiService } from "../../../services/ApiService";
import { ConfirmTemplate } from "../../../components/confirm";
import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import { muchAndLearnMngtThunk } from "../../../store/actions/trainingmanagement/training.thunk";
import { employeeMngtThunk } from "../../../store/actions/employeemanagement/employee.thunk";

import useModal from "../../../utils/useModal";
import Modal from "react-modal";
import EditMunch from "./edit_munch";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

export const ViewAllMunch = () => {
  const alert = useAlert();
  const [munch, setMunch] = useState({});
  const { modalIsOpen, openModal, closeModal } = useModal();
  const { muchAndLearn } = useSelector((state) => state.trainingMngt);
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();

  const getAllMuchAndLearns = useCallback(async () => {
    await dispatch(muchAndLearnMngtThunk.getAllMuchAndLearn());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
  }, [dispatch]);

  useEffect(() => {
    getAllMuchAndLearns();
  }, []);

  const deleteRequest = (ids) => {
    const request = async () => {
      const id = {
        id: ids,
      };
      const res = await ApiService.delete(`delete-munch-learn/${id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getAllMuchAndLearns();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Munch And Learn",
        message: "Are You Sure You Want To Delete This Munch and Learn",
      },
      request
    );
  };

  return (
    <React.Fragment>
      <TrainingNavbar />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="add cases modal"
      >
        <EditMunch
          closeModal={closeModal}
          alert={alert}
          users={employees}
          getThemes={getAllMuchAndLearns}
          munch={munch}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="table-wrapper table-responsive">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-xs-12"
                    id="munch_learn_content_wrapper"
                  >
                    <div class="">
                      <table
                        id="munch_learn_view"
                        class="table table-striped table-bordered learn-table"
                      >
                        <thead>
                          <tr>
                            <th class="th-sm">
                              <b> NO </b>
                            </th>
                            <th class="th-sm" style={{ width: "250px" }}>
                              <b> NAME </b>
                            </th>
                            <th class="th-sm" style={{ width: "200px" }}>
                              <b> DUE DATE </b>
                            </th>
                            <th class="th-sm" style={{ width: "270px" }}>
                              <b> PRESENTATION TYPE </b>
                            </th>
                            <th class="th-sm" style={{ width: "270px" }}>
                              <b> TOPIC </b>
                            </th>
                            <th class="th-sm" style={{ width: "200px" }}>
                              <b> EMAIL </b>
                            </th>
                            <th class="th-sm notexport">
                              <b>ACTION</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {muchAndLearn.map((munch, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{munch.name}</td>
                              <td>{munch.due_date}</td>
                              <td>{munch.presentation_type}</td>
                              <td>{munch.topic}</td>
                              <td>{munch.email}</td>
                              <td>
                                <div class="dropdown">
                                  <a
                                    href="#"
                                    class="dropdown-toggle card-drop arrow-none"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <h3 class="m-0 text-muted">
                                      <i class="fa fa-ellipsis-v"></i>
                                    </h3>
                                  </a>
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="btnGroupDrop1"
                                  >
                                    {/* <Link
                                      to={`/dashboard/training/edit-munch/${btoa(
                                        munch.id
                                      )}`}
                                      className="dropdown-item"
                                    >
                                      Edit
                                    </Link> */}
                                    <a
                                      className="edit_munch"
                                      id="edit_munch"
                                      onClick={() => {
                                        const value = {
                                          id: munch.id,
                                          name: munch.name,
                                          presentation_type:
                                            munch.presentation_type,
                                          due_date: munch.due_date,
                                          email: munch.email,
                                          users_email: munch.users_email,
                                          topic: munch.topic,
                                        };
                                        console.log("munch", value);
                                        setMunch(value);
                                        openModal();
                                      }}
                                    >
                                      Edit
                                    </a>

                                    <a
                                      class="dropdown-item"
                                      onClick={() => {
                                        deleteRequest(munch.id);
                                      }}
                                    >
                                      Delete
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/view_all.js